import { checkHttpStatusAuthCheck } from '../../../actions/utilAction';
import {
  actionCreator,
  checkHttpStatus,
  createSearchUrlForCustomAPI,
  DELETE_PAYER_ACTIVITY_CODE,
  DELETE_PAYER_INFO,
  DELETE_PAYER_SERVICE_CODES,
  EXCLUDED_SERVICE_CODES,
  GET_ACTIVITY_LIST,
  GET_ACTIVITY_SERVICE_CODE_BY_ID,
  GET_ALL_PAYER_SERVICE_CODES,
  GET_MASTER_STATE_BY_COUNTRYID,
  GET_MASTERDATABYNAME,
  GET_MASTERSERVICECODE_BYID,
  GET_PAYER_ACTIVITY_SERVICE_CODES,
  GET_PAYER_INFO_BY_ID,
  GET_PAYER_OR_MASTER_SERVICE_CODES,
  GET_PAYER_SERVICE_CODE_BY_ID,
  GET_PAYER_SERVICECODE_BY_ID,
  GET_PAYER_SERVICECODE_MODIFIER_DEPENDENCY,
  GET_PAYERS_LIST,
  jsonApiHeader,
  MASTER_ACTIVITY_FOR_PAYER,
  PAYER_INFO_SAVE,
  payerActionTypes,
  SAVE_NEW_SERVICE_CODE_IN_ACTIVITY,
  SAVE_PAYER_SERVICE_CODES,
  SAVE_PAYER_SINGLE_SERVICE_CODE,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
  UPDATE_ACTIVITY_SERVICE_CODE_MODIFIER,
  PAYERACTIVITY_STATUS_ACTIVATION,
} from './../constants/ApiConstants';
import Alert from 'react-s-alert';

export const getMasterData = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.get_master_data.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'MASTERINSURANCETYPE,masterCountry,masterState,appointmentType,masterservicecode,masterunittype,masterroundingrules,MASTEREVVDETAILS,MASTERNOTETYPE' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
    .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(payerActionTypes.get_master_data.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error payer ...', error);
      });
  };
};
export const getPayersList = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(payerActionTypes.get_payers_list.REQUEST));
    fetch(`${GET_PAYERS_LIST}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('response: ', response);
        if (response) {
          dispatch(actionCreator(payerActionTypes.get_payers_list.SUCCESS, response));
        }
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};

export const getPayerInfoById = (payerId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.get_payer_info_by_id.REQUEST));
    fetch(`${GET_PAYER_INFO_BY_ID}/${payerId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(payerActionTypes.get_payer_info_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};

export const SavePayerInfo = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.post_payer_info.REQUEST));
    fetch(`${PAYER_INFO_SAVE}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(payerActionTypes.post_payer_info.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(payerActionTypes.post_payer_info.FAILURE));
        }
      });
  };
};
export const deletePayerData = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.delete_payer_info.REQUEST));

    fetch(`${DELETE_PAYER_INFO}/${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        // console.log('response.....',response)
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(payerActionTypes.delete_payer_info.SUCCESS, response));
        } else {
          dispatch(actionCreator(payerActionTypes.delete_payer_info.SUCCESS, null));
          showErrorMessage(response.message);
        }
      }).catch(function(error) {
        // console.log(error);
      });
  };
};

export const getMasterStateByCountryId = (countryId) => {
  return (dispatch, getState) => {
    fetch(`${GET_MASTER_STATE_BY_COUNTRYID}/?countryID=${countryId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(payerActionTypes.get_master_state_by_countryid.SUCCESS, response.data));
      })
      .catch(function(error) {
        console.log('error: ', error);
      });
  };
};
export const getPayerOrMasterServiceCodes = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(payerActionTypes.get_payer_or_master_service_codes.REQUEST));
    fetch(`${GET_PAYER_OR_MASTER_SERVICE_CODES}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(payerActionTypes.get_payer_or_master_service_codes.SUCCESS, response));
        } else {
          dispatch(actionCreator(payerActionTypes.get_payer_or_master_service_codes.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};


export const resetServiceCodeDetails = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.reset_ServiceCodeDetails.REQUEST));
  };
};

export const getPayerServiceCodeById = (payerServiceCodeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.get_payer_service_code_by_id.REQUEST));
    fetch(`${GET_PAYER_SERVICE_CODE_BY_ID}?payerServiceCodeId=${payerServiceCodeId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(payerActionTypes.get_payer_service_code_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};
export const SavePayerServiceCodes = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.save_payer_service_codes.REQUEST));
    fetch(`${SAVE_PAYER_SERVICE_CODES}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(payerActionTypes.save_payer_service_codes.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(payerActionTypes.save_payer_service_codes.FAILURE));
        }
      })
      .catch(function(error) {
        // console.log(error);
      });
  };
};
export const deletePayerServiceCode = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.delete_payer_service_code.REQUEST));

    fetch(`${DELETE_PAYER_SERVICE_CODES}?payerServiceCodeId=${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        // console.log('response.....',response)
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(payerActionTypes.delete_payer_service_code.SUCCESS, response));
        } else if (response.statusCode === 401) {
          showWarningMessage(response.message);
          dispatch(actionCreator(payerActionTypes.delete_payer_service_code.SUCCESS, null));
        } else {
          dispatch(actionCreator(payerActionTypes.delete_payer_service_code.SUCCESS, null));
          showErrorMessage(response.message);
        }
      }).catch(function(error) {
        // console.log(error);
      });
  };
};
export const CheckPayerServiceCodeModifierDependency = (modifierId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.get_payer_servicecode_modifier_dependency.REQUEST));
    fetch(`${GET_PAYER_SERVICECODE_MODIFIER_DEPENDENCY}?payerModifierId=${modifierId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 401) {
          showWarningMessage(response.message);
        }
        dispatch(actionCreator(payerActionTypes.get_payer_servicecode_modifier_dependency.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error payer ...', error);
      });
  };
};
export const getAllPayerCptCodeByPayerId = (payerID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.get_all_payer_cpt_codes_by_payer.REQUEST));
    fetch(`${GET_ALL_PAYER_SERVICE_CODES}?payerID=${payerID}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(payerActionTypes.get_all_payer_cpt_codes_by_payer.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error payer ...', error);
      });
  };
};
export const GetMasterServiceCodeById = (serviceCodeId) => {
  // console.log('serviceCodeId..........',serviceCodeId)
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.get_masterservicecode_by_Id.REQUEST));
    // let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_MASTERSERVICECODE_BYID}?serviceCodeId=${serviceCodeId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response..........',response)
        dispatch(actionCreator(payerActionTypes.get_masterservicecode_by_Id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error payer ...', error);
      });
  };
};
export const getActivities = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(payerActionTypes.get_payer_activity.REQUEST));
    fetch(`${GET_ACTIVITY_LIST}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 405 && response.statusCode !== 204) {
          dispatch(actionCreator(payerActionTypes.get_payer_activity.SUCCESS, response));
        } else {
          dispatch(actionCreator(payerActionTypes.get_payer_activity.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};
export const deletePayerActivityCode = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.delete_payer_activity_code.REQUEST));

    fetch(`${DELETE_PAYER_ACTIVITY_CODE}?id=${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        // console.log('response.....',response)
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(payerActionTypes.delete_payer_activity_code.SUCCESS, response));
        } else {
          dispatch(actionCreator(payerActionTypes.delete_payer_activity_code.SUCCESS, null));
          showErrorMessage(response.message);
        }
      }).catch(function(error) {
        // console.log(error);
      });
  };
};
export const getAppointmentTypeForPayer = (payerId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.get_master_activity_for_payer.REQUEST));
    fetch(`${MASTER_ACTIVITY_FOR_PAYER}?PayerId=${payerId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        if (response) {
          dispatch(actionCreator(payerActionTypes.get_master_activity_for_payer.SUCCESS, response));
        }
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};
export const getPayerActivityCptCodes = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(payerActionTypes.get_payer_activity_service_codes.REQUEST));
    fetch(`${GET_PAYER_ACTIVITY_SERVICE_CODES}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        if (response) {
          dispatch(actionCreator(payerActionTypes.get_payer_activity_service_codes.SUCCESS, response));
        }
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};
export const getExcludedServiceCodesFromActivity = (payerId, activityId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.excluded_service_codes.REQUEST));
    fetch(`${EXCLUDED_SERVICE_CODES}?PayerId=${payerId}&ActivityId=${activityId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        if (response) {
          dispatch(actionCreator(payerActionTypes.excluded_service_codes.SUCCESS, response));
        }
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};
export const SaveServiceCodesInActivity = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.save_new_service_code_in_activity.REQUEST));
    fetch(`${SAVE_NEW_SERVICE_CODE_IN_ACTIVITY}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(payerActionTypes.save_new_service_code_in_activity.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(payerActionTypes.save_new_service_code_in_activity.FAILURE));
        }
      });
  };
};
export const updatePayerAppointmentTypeCodeModifiers = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.update_activity_service_code_modifier.REQUEST));
    fetch(`${UPDATE_ACTIVITY_SERVICE_CODE_MODIFIER}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(payerActionTypes.update_activity_service_code_modifier.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(payerActionTypes.update_activity_service_code_modifier.FAILURE));
        }
      });
  };
};


export const getActivityServiceCodeById = (payerAppointmentTypeId, payerServiceCodeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.get_activity_service_code_by_id.REQUEST));
    fetch(`${GET_ACTIVITY_SERVICE_CODE_BY_ID}?payerAppointmentTypeId=${payerAppointmentTypeId}&payerServiceCodeId=${payerServiceCodeId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(payerActionTypes.get_activity_service_code_by_id.SUCCESS, response));
        } else {
          dispatch(actionCreator(payerActionTypes.get_activity_service_code_by_id.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};
export const GetPayerServiceCodeById = (payerServiceCodeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.get_payer_servicecode_by_Id.REQUEST));
    // let query_params = createSearchUrlForCustomAPI(searchObj);
    // console.log(`${GET_PAYER_SERVICECODE_BY_ID}?payerServiceCodeId=${payerServiceCodeId}`);
    fetch(`${GET_PAYER_SERVICECODE_BY_ID}?payerServiceCodeId=${payerServiceCodeId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response............',response)
        dispatch(actionCreator(payerActionTypes.get_payer_servicecode_by_Id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error payer ...', error);
      });
  };
};
export const SaveSinglePayerServiceCode = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.save_single_payer_service_code.REQUEST));
    fetch(`${SAVE_PAYER_SINGLE_SERVICE_CODE}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(payerActionTypes.save_single_payer_service_code.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(payerActionTypes.save_single_payer_service_code.SUCCESS, null));
        }
      })
      .catch(function(error) {
        // console.log(error);
      });
  };
};

export const UpdatePayerActivityStatus = (appointmentTypeID, IsActivate, payerId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(payerActionTypes.patch_payeractivity_active_status.REQUEST));
    fetch(`${PAYERACTIVITY_STATUS_ACTIVATION}?appointmentTypeID=${appointmentTypeID}&isActive=${IsActivate}&payerId=${payerId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(payerActionTypes.patch_payeractivity_active_status.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(payerActionTypes.patch_payeractivity_active_status.SUCCESS, {}));
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
        dispatch(actionCreator(payerActionTypes.patch_payeractivity_active_status.SUCCESS, {}));
      });
  };

};

export const ResetPayerId = () => {
  return(dispatch) => {
    dispatch(actionCreator(payerActionTypes.get_payer_info_by_idReset.SUCCESS, null));
  }
}



// WEBPACK FOOTER //
// ./src/modules/Payers/actions/index.js